module.exports = __webpack_public_path__ + "img/ats.0b0b1935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ats.png
// module id = DUlS
// module chunks = 1